import { render } from "./AdobeSignTab.vue?vue&type=template&id=35ae2fc2&scoped=true&lang=pug"
import script from "./AdobeSignTab.vue?vue&type=script&lang=js"
export * from "./AdobeSignTab.vue?vue&type=script&lang=js"

import "./AdobeSignTab.vue?vue&type=style&index=0&id=35ae2fc2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ae2fc2"]])

export default __exports__